<script>
import 'magnific-popup';
import $ from 'jquery';

export default {
    name: "video-content-item",
    data() {
        return {
            videoLink: null
        }
    },
    methods: {
        zoomVideo: function(event) {
            event.preventDefault();
        },
        initMagnificPopup() {
            $(this.$refs.videoLink).magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
                callbacks: {
                    open: function() {
                        $('.mfp-content').css({
                            'max-width': '80%',
                        });
                        $('.mfp-iframe-scaler').css({
                            'padding-top': '56.25%'
                        });
                    }
                },
                iframe: {
                    patterns: {
                        vimeo: {
                            index: 'vimeo.com/',
                            id: function(url) {
                                return url.split('/').pop();
                            },
                            src: '//player.vimeo.com/video/%id%?autoplay=1&title=0&byline=0&portrait=0&fullscreen=1'
                        }
                    }
                }
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initMagnificPopup();
        });
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        videoThumbnailSrc: {
            type: String,
            required: true
        },
        videoUrl: {
            type: String,
            required: true
        },
        playIcon: {
            type: String,
            default: '<svg height="512px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M405.2,232.9L126.8,67.2c-3.4-2-6.9-3.2-10.9-3.2c-10.9,0-19.8,9-19.8,20H96v344h0.1c0,11,8.9,20,19.8,20  c4.1,0,7.5-1.4,11.2-3.4l278.1-165.5c6.6-5.5,10.8-13.8,10.8-23.1C416,246.7,411.8,238.5,405.2,232.9z"></path></svg>'
        }
    }
}
</script>

<template>
    <div>
        <h3 v-if="title && title.length > 0">{{ title }}</h3>
        <div class="zoom-video-wrapper text-start">
            <div class="zoom-video">
                <a 
                    ref="videoLink"
                    :href="videoUrl" 
                    @click="zoomVideo"
                    class="no-hover-effect"
                >
                    <img :src="videoThumbnailSrc" :alt="title">
                    <div v-html="playIcon"></div>
                </a>
            </div>
        </div>
    </div>
</template>